module.exports = __webpack_public_path__ + "media/96.3fe8ae2f.mp3";